(() => {
  const inputs = document.querySelectorAll('rx-sunglasses-builder input[name^="rx-pd-method"][value="help"]');
  inputs.forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked || !window.matchMedia('(max-width: 749px)').matches) return;
      const builder = input.closest('rx-sunglasses-builder');
      setTimeout(() => {
        if (!input.checked) return;
        const body = builder?.querySelector('[data-rx-dialog-body]');
        const heading = builder?.querySelector('[data-rx-pd-help-heading]');
        if (!body || !heading) return;
        heading.focus({ preventScroll: true });
        const bodyTop = body.getBoundingClientRect().top;
        const headingTop = heading.getBoundingClientRect().top;
        body.scrollTo({
          top: Math.max(0, body.scrollTop + headingTop - bodyTop - 14),
          behavior: 'auto'
        });
      }, 160);
    });
  });
})();
